import { render, staticRenderFns } from "./atajosDashboard.vue?vue&type=template&id=4740f7c8&scoped=true"
import script from "./atajosDashboard.vue?vue&type=script&lang=js"
export * from "./atajosDashboard.vue?vue&type=script&lang=js"
import style0 from "./atajosDashboard.vue?vue&type=style&index=0&id=4740f7c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4740f7c8",
  null
  
)

export default component.exports